
import { CheckLicenseActions, CheckLicenseActionTypes } from '../actions/check-license.actions';
import {CheckLicenseModel} from '../check-license.model';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  isChecked: boolean;
  entities: CheckLicenseModel;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  isChecked: false,
  entities: {}
};

export function reducer(state = initialState, action: CheckLicenseActions): State {
  switch (action.type) {

    case CheckLicenseActionTypes.GetCheckLicenses:
      return {...state, isLoaded: false, isLoading: true, isChecked: false};

    case CheckLicenseActionTypes.LoadCheckLicenses:
      return {...state, isLoaded: true, isLoading: false, isChecked: true, entities: action.payload};

    case CheckLicenseActionTypes.ClearCheckLicenses:
      return {...state, isLoaded: false, isLoading: true, isChecked: false, entities: {}};

    default:
      return state;
  }
}
